import { render, staticRenderFns } from "./DownModal.vue?vue&type=template&id=db2eb97a&scoped=true"
import script from "./DownModal.vue?vue&type=script&lang=js"
export * from "./DownModal.vue?vue&type=script&lang=js"
import style0 from "./DownModal.vue?vue&type=style&index=0&id=db2eb97a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2eb97a",
  null
  
)

export default component.exports